export const LAYER_TYPE = {
    TOUR: 'tour',
    INTERACTION_COLLECTOR: 'c-overlay',
    ERROR_COLLECTOR: 'e-overlay',
    APPLICATION_AUGMENTATION: 'a-overlay',
    RECORDING: 'recording',
} as const;

export const LAYER_NODE_PERSIST = {
    OFF: 'off',
    ON_NAVIGATE: 'on_navigate',
    ON_RELOAD: 'on_reload',
    ON_BACK_FORWARD: 'on_back_forward',
    ANY: 'any',
} as const;

export const ANIMATION_TYPE = {
    NO: 'NO',
    FADE: 'FADE',
    ZOOM: 'ZOOM',
    TRANSITION: 'TRANSITION',
} as const;
